import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:LocationType');

export default class LocationTypesService {
  constructor(genericConfigService) {
    this.genericConfigService = genericConfigService;
    this.types = ['home', 'travel_in'];
  }

  getLocationTypes() {
    debug.info('getlocationTypes', this.types);
    return this.genericConfigService.getConfig()
      .then(config => config.locations_types || [])
      .then(enabledTypes => this.types.filter(t => enabledTypes.indexOf(t) !== -1))
      .catch(err => { debug.error('error: %o', err); throw err; });
  }

  getDefault() {
    return this.getLocationTypes()
      .then(types => {
        if (types.length) {
          return [types[0]]; // TODO better logic
        }

        throw new Error('no location types');
      });
  }
}

Injector.service('locationTypesService', ['genericConfigService'], LocationTypesService);



// WEBPACK FOOTER //
// ./src/services/LocationTypesService.js